import { ReactNode } from 'react';
import cn from 'classnames';

interface CardsContainerProps {
  children: ReactNode;
  className?: string;
}

export default function CardsContainer({
  children,
  className,
}: CardsContainerProps) {
  return (
    <article
      className={cn(
        `grid grid-cols-1 gap-x-6 gap-y-10 md:grid-cols-2 md:gap-y-20 lg:grid-cols-3`,
        className,
      )}
    >
      {children}
    </article>
  );
}
